import { useSetEventDetailData } from "recoil/hooks/useEventDetailData";
import { getEventDetail } from "services/events";
import { useSetFetchError } from "recoil/hooks/useFetchError";

export function useEventMutations() {

  const setEvent = useSetEventDetailData();
  const setError = useSetFetchError();

  const getEventDetailData = async function (id: string) {
    const data = await getEventDetail(id);
    setError(data.state);
    setEvent(data.data);
  };

  return { getEventDetailData };
}